export const STORED_POWER_LOG_LIST_REQUEST = 'STORED_POWER_LOG_LIST_REQUEST';
